import { OnDestroy } from "@angular/core";
import { Article, CreateGroupResult, CreateGroupVariant, EntryStatus, Group, GroupBasketItemUiData, GroupMemberUiData, GroupUiData, HttpStatusCode, IGroupManageData, ILocationData, IRemoteGroupBasketItemExtra, IRemoteGroupOrderService, Member, MemberStatus, PostGroupArgs, Status } from "./IRemoteGroupOrderService";
import { WebShopService } from "./webShop.service";
import { LocationService } from "../components/location/location.service";
import { WebShopMode } from "./IWebShopService";
import * as moment from "moment";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import Utils from "../shared/utils";
import { CoreCOMService } from "./com.service";
import { LocalKeys, StorageHive } from "./valueStorage.service";
import { CoreLogService } from "./log.service";
import { appConfig } from "../core-config";
import { snackBarMessageKey, SnackBarService } from "./snackBar.service";
import { ProductService } from "./product.service";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ProductDetailsHelperService } from "./product_details_helper.service";
import { ProductDataModel4, ProductDetailsDataModel3 } from "../shared/models";
import { ConnectionState } from "./YourAppServer/YourAppServerSoket.service";
import { SnackBarMessageType } from "../shared/contentTypes";
import { Router } from "@angular/router";
import { BottomSheetHelperService } from "./bottomSheetHelper.service";
import { ConfirmationModalDialogComponent } from "../modalDialogs/confirmationModalDialog/confirmationModalDialog.component";
import { SecureCheckDialogComponent } from "../modalDialogs/secureCheckDialog/secureCheckDialog.component";
import { CoreLanguageService } from "./language.service";
import { WarningdialogComponent } from "../modalDialogs/warningDialog/warningDialog.component";

export class GroupEntryDone {
  /**Entry group was successful */
  success: boolean = false;
  /** Entry  groupstatus, if not successful */
  status: EntryStatus = EntryStatus.Error;
  /** Group information, if successful */
  groupData: GroupManageData = null;
}

class CachedRemoteGroupOrderData {
  public groupId: number;
  public groupName: string;
  public creatorName: string;
  public userName: string;
  public groupDeliveryAddress: string;
  public selectedServiceTime: string;
  public selectedOrderTime: string;
  public locationID: number;
  public userId: number;
  public serviceMode: WebShopMode;
  public cachedAt_YMD: number = -1;
  public cachedAt_HMS: number = -1;
}

class CacheGroupSummary {
  public groupId: number;
  public groupName: string;
  public preOrdervariant: number;
  public deliveryAddress: string;
  public status: Status;
  public userId: number;
  public count: number;
  public price: number;
  public serviceTime: string;
  public locationID: number;
  public cachedAt_YMD: number = -1;
  public cachedAt_HMS: number = -1;
}

class GroupManageData implements IGroupManageData {
  public creatorName: string = "";
  public groupId: number = 0;
  public groupName: string = "";
  public groupDeliveryAddress: string = "";
  public selectedServiceTime: string = "";
  public selectedOrderTime: string = "";
  public userId: number = 0;

  public updateFromCache(cachedData: CachedRemoteGroupOrderData) {
    const me = this;
    me.groupName = cachedData.groupName;
    me.groupId = cachedData.groupId;
    me.creatorName = cachedData.creatorName;
    me.groupDeliveryAddress = cachedData.groupDeliveryAddress;
    me.selectedServiceTime = cachedData.selectedServiceTime;
    me.selectedOrderTime = cachedData.selectedOrderTime;
    me.userId = cachedData.userId;
  }
}

export class RemoteGroupOrderService implements IRemoteGroupOrderService, OnDestroy {

  constructor(private _webshopService: WebShopService
    , private _objObsInjectHelper: CircularInjectionHelper
    , private _productService: ProductService
    , private _locationService: LocationService
    , private _coreCOMService: CoreCOMService
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _snackBarService: SnackBarService
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService) {
    const me = this
    me._updateFromCache().then(() => {
      me.initSignalRIfDataAvailable(me.currentLocationID, me.groupId, me.userId);

      // falls serviceId bzw. webshopMode verfügbar muss das bei webshopService gesetzt werden
      if (!Utils.IsNull(me.serviceMode)) {
        me._webshopService.changeServiceMode(me.serviceMode).then(async () => {
          await me._webshopService.setServiceLocationByID(me.currentLocationID);
          await me.loadBasketData();
        });
        // TODO, ist es notwendig adrese bei lieferung anzugeben? me._webshopService.setServiceLocationInfo
      }
    });

    // TODO: remove after debugging
    (window as any).webshopService = this._webshopService;
    (window as any).remoteGroupOrderService = this;

    // TODO: remove after debugging
    (window as any).broadcast = (message: string) => {
      me.SignalR_BroadcastMessage(message);
    }
  }

  private initSignalR(locationId: number, groupId: number, memberId: number) {
    const me = this;
    // this is triggered, regardless of the page lifetime
    me._webshopService._objObsInjectHelper.ObserveOnInit.subscribe(async () => {
      const socket = me.GetSocket();
      // this must not be awaited otherwise the ObserveOpend will not be triggered
      socket.Connect(locationId);

      socket.ObserveOpend.subscribe(async () => {
        await this.SignalR_JoinGroup(groupId, memberId);
        // this was needed for debugging
        // leaving it in for now, if it is needed again
        // console.info("successfully connected to signalr with:");
        // console.log({ locationId, groupId, memberId })
      });

      // TODO: implement them
      // socket.ObserveReconnecting.subscribe(() => {
      //   // debugger
      //   console.log("reconnecting")
      // });
      // socket.ObserveReconnected.subscribe(() => {
      //   // debugger
      //   console.log("reconnected")
      // });
      // socket.ObserveClosed.subscribe(() => {
      //   // debugger
      //   console.log("closed")
      // });

      me.bindSignalREvents();
    });
  }

  private async closeSignalR(): Promise<void> {
    const socket = this.GetSocket();
    if (socket.Status !== ConnectionState.Disconnected) {
      await socket.Disconnect();
    }
  }

  private initSignalRIfDataAvailable(locationId: number, groupId: number, memberId: number) {
    const me = this;
    if (locationId && groupId && memberId) {
      me.initSignalR(locationId, groupId, memberId);
    } else {
      // for now unly uncommented, in case it is needed for further debugging
      // console.error("no data available for initSignalR")
      // console.error({ locationId, groupId, memberId })
    }
  }

  private _locationId: number;
  public get currentLocationID() {
    const me = this;
    return me._locationId;
  }

  private _serviceMode: WebShopMode;
  public get serviceMode() {
    const me = this;
    return me._serviceMode;
  }

  public get isGroupDelivery(): boolean {
    const me = this;
    return me.serviceMode === WebShopMode.DeliveryGroup;
  }

  public _currentData: CachedRemoteGroupOrderData = new CachedRemoteGroupOrderData();
  public groupSummary: CacheGroupSummary = new CacheGroupSummary();

  private locationDataSubject: BehaviorSubject<ILocationData> = new BehaviorSubject<ILocationData>(null);
  public locationData$: Observable<ILocationData> = this.locationDataSubject.asObservable();

  private _displayGroupNavSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get displayGroupNav$(): Observable<boolean> {
    return this._displayGroupNavSubject.asObservable();
  }

  private _uiDataChanged: Subject<IGroupManageData> = new Subject();

  private _groupManageData: GroupManageData = new GroupManageData();
  public get groupManageData(): IGroupManageData {
    return this._groupManageData;
  }

  public get currentData() {
    return this._groupManageData;
  }

  private _groupName: string = "";
  public get groupName(): string {
    const me = this;
    return me._groupManageData.groupName;
  }

  /**
   * Returns true if a group name is defined in the current session
   * or already exists in the active/cached group data.
   */
  public get hasDefinedGroupName(): boolean {
    const me = this;
    const hasCurrentGroupName = !Utils.IsNullOrWhiteSpace(me._groupName);
    const hasCachedGroupName = !!me._groupManageData && !Utils.IsNullOrWhiteSpace(me._groupManageData.groupName);
    return hasCurrentGroupName || hasCachedGroupName;
  }

  /** Returns true if a group order deadline has been set in-session or restored from cache. */
  public get hasDefinedGroupOrderTime(): boolean {
    const me = this;
    const hasCurrentOrderTime = !Utils.IsNullOrWhiteSpace(me.orderTime);
    const hasCachedOrderTime = !!me._groupManageData && !Utils.IsNullOrWhiteSpace(me._groupManageData.selectedOrderTime);
    return hasCurrentOrderTime || hasCachedOrderTime;
  }

  private _groupId: number = 0;
  public get groupId(): number {
    const me = this;
    return me._groupManageData.groupId;
  }

  private _creatorName: string = "";
  public get creatorName(): string {
    const me = this;
    return me._groupManageData.creatorName;
  }

  private _creatorId: number = 1;
  /** Creator id */
  public get creatorId(): number {
    const me = this;
    return me._creatorId;
  }

  /** Current user id*/
  private _userId: number = 0;
  public get userId(): number {
    const me = this;
    return me._groupManageData.userId;
  }

  /** Current user name*/
  private _userName: string = "";
  public get userName(): string {
    const me = this;
    return me._userName;
  }
  /** Delivery address */
  public get groupDeliveryAddress() {
    const me = this;
    return me._groupManageData.groupDeliveryAddress;
  }

  /** Dtate for all members */
  private _allMembersAreReadySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get allMembersAreReady$(): Observable<boolean> {
    return this._allMembersAreReadySubject.asObservable();
  }

  /** Member count */
  private _memberCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get memberCount$(): Observable<number> {
    return this._memberCountSubject.asObservable();
  }

  /** All items count  */
  private _groupBasketItemsCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get groupBasketItemsCount$(): Observable<number> {
    return this._groupBasketItemsCountSubject.asObservable();
  }
  /** All items sum*/
  private _groupbasketTotalPriceSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get groupBasketTotalPrice$(): Observable<number> {
    return this._groupbasketTotalPriceSubject.asObservable();
  }

  /** Group code */
  private _remoteGroupCode: string = "";
  public get remoteGroupCode(): string {
    const me = this;
    return me._remoteGroupCode;
  }

  /** Member order state */
  private _stateReadySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get stateReady$(): Observable<boolean> {
    return this._stateReadySubject.asObservable();
  }

  /** Members data changed */
  private _membersChangedSubject: Subject<void> = new Subject<void>();
  public get membersChanged$(): Observable<void> {
    return this._membersChangedSubject.asObservable();
  }
  /** Members state changed */
  private _memberStateChangedSubject: Subject<void> = new Subject<void>();
  public get memberStateChanged$(): Observable<void> {
    return this._memberStateChangedSubject.asObservable();
  }

  /** Items data changed */
  private _itemsChangedSubject: Subject<void> = new Subject<void>();
  public get itemsChanged$(): Observable<void> {
    return this._itemsChangedSubject.asObservable();
  }

  /** Group deleted */
  private _groupDeletedSubject: Subject<void> = new Subject<void>();
  public get groupDeleted$(): Observable<void> {
    return this._groupDeletedSubject.asObservable();
  }

  /** Group status */
  private _groupStatusChangedSubject: Subject<void> = new Subject<void>();
  public get groupStatusChanged$(): Observable<void> {
    return this._groupStatusChangedSubject.asObservable();
  }

  /** Handles the payment started status and updates the ability to add / change items.*/
  private _groupStatusPaymentStartedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get groupStatusPaymentStarted$(): Observable<boolean> {
    return this._groupStatusPaymentStartedSubject.asObservable();
  }

  /**Handles the group status 'Finished'*/
  private _groupStatusFinishedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get groupStatusFinished$(): Observable<boolean> {
    return this._groupStatusFinishedSubject.asObservable();
  }

  private _groupNotActiveSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get groupNotActive$(): Observable<boolean> {
    return this._groupNotActiveSubject.asObservable();
  }

  private _notifyCreatorAllMembersAreReady: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get notifyCreatorAllMembersAreReady$(): Observable<boolean> {
    return this._notifyCreatorAllMembersAreReady.asObservable();
  }

  private _displaySummarySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get displaySummary$(): Observable<boolean> {
    return this._displaySummarySubject.asObservable();
  }

  private orderTimeout: NodeJS.Timer = null;

  private resetGroupPaymentState() {
    const me = this;
    me._groupStatusFinishedSubject.next(false);
    me._groupStatusPaymentStartedSubject.next(false);
  }

  // region Cache
  /** Updates group data from cache. */
  private async _updateFromCache(): Promise<void> {
    const me = this;
    const cachedData = await me.UpdateAndLoadCacheData();
    if (cachedData) {
      me._groupManageData = new GroupManageData();
      me._groupManageData.updateFromCache(cachedData);
      me._displayGroupNavSubject.next(!Utils.IsNull(cachedData.userId) && cachedData.userId > 0);
      me._locationId = cachedData.locationID;
      me._serviceMode = cachedData.serviceMode;
    }
  }

  /**Caches current data with the current timestamp. */
  private CacheData(): Promise<void> {
    const me = this;
    const now = moment();
    me._currentData.cachedAt_YMD = Utils.GetYMDFromMoment(now);
    me._currentData.cachedAt_HMS = Utils.GetHMSFromMoment(now);
    return me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.remoteGroupOrder, me._currentData);
  }

  /** Cleans up cached data. */
  private CleanupCacheData(): Promise<void> {
    return this._coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.remoteGroupOrder);
  }

  public async setCacheGroupSummary(): Promise<void> {
    // Validate IDs early to avoid unnecessary operations
    if (!this.groupId || !this.userId) {
      this.handleError("setCacheGroupSummary: Missing groupId or userId", null);
      return;
    }
    const [_httpStatusCode, group] = await this.GetGroup(this.groupId);
    if (!group) {
      this.handleError("setCacheGroupSummary: Error retrieving group data", "Group not found");
      return;
    }
    const now = moment();
    this.groupSummary = {
      cachedAt_YMD: Utils.GetYMDFromMoment(now),
      cachedAt_HMS: Utils.GetHMSFromMoment(now),
      groupId: this.groupId,
      userId: this.userId,
      preOrdervariant: group.PreOrderType.Variant,
      deliveryAddress: this.groupDeliveryAddress,
      groupName: group.Name,
      status: group.Status,
      serviceTime: group.ServiceTimestamp || null,
      locationID: group.HypCusNr || null,
      count: Object.values(group.Basket || {}).reduce((count, items) => count + items.length, 0),
      price: group.TotalPaidPrice,
    };
    await this._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.groupSummary, this.groupSummary);
  }

  public async getCacheGroupSummary(): Promise<CacheGroupSummary | null> {
    try {
      const cachedData: CacheGroupSummary | null = await this._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.groupSummary);

      if (cachedData) {
        const now = moment();
        const serviceTime = moment(cachedData.serviceTime); // Assuming serviceTime is stored correctly
        const cachedAt = Utils.GetMomentFromInt(cachedData.cachedAt_YMD, cachedData.cachedAt_HMS);

        // Expire cache if service time has passed OR cache is older than 24 hours
        if (serviceTime.isBefore(now) || moment.duration(now.diff(cachedAt)).asHours() >= 24) {
          await this.cleanupGroupSummary();
          return null;
        }
      }
      return cachedData;
    } catch (error) {
      this.handleError("getCacheGroupSummary: Error retrieving cache data", error);
      return null;
    }
  }

  private async cleanupGroupSummary(): Promise<void> {
    await this._coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.groupSummary);
  }

  public async handleCacheGroupSummary(): Promise<void> {
    try {
      const cachedSummary = await this.getCacheGroupSummary();
      const hasSummary = cachedSummary && cachedSummary !== null
      this._displaySummarySubject.next(hasSummary);
    } catch (error) {
      this.handleError("Error handling cached group data:", error);
    }
  }

  /**
   * Updates and retrieves cached data.
   * @returns The cached data or null.
   */
  private UpdateAndLoadCacheData(): Promise<CachedRemoteGroupOrderData> {
    const me = this;
    return new Promise<CachedRemoteGroupOrderData>(async (resolve, reject) => {
      try {
        let cachedData: CachedRemoteGroupOrderData = await me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.remoteGroupOrder);
        if (cachedData) {
          const cachedAt = Utils.GetMomentFromInt(cachedData.cachedAt_YMD, cachedData.cachedAt_HMS);
          const now = moment()
          if (cachedAt > now || moment.duration(now.diff(cachedAt)).asHours() >= 24) {
            me.CleanupCacheData();
            cachedData = null;
          }
        }
        resolve(cachedData);
      } catch (error) {
        me.handleError("updateCacheData valueStorage.get.catch ", error)
        reject(error);
      }
    });
  }

  //#endregion Cache

  /** Initializes and caches group data, then updates the UI.*/
  private _setGroupDataValue() {
    const me = this;
    //Setting Current Data Values:
    me._currentData.groupId = me._groupId;
    me._currentData.groupName = me._groupName;
    me._currentData.creatorName = me._creatorName;
    me._currentData.userName = me._userName;
    me._currentData.groupDeliveryAddress = me.serviceMode === WebShopMode.DeliveryGroup ? me._webshopService.currentlyUsedAddress : "";
    me._currentData.selectedServiceTime = me.serviceTime;
    me._currentData.selectedOrderTime = me.orderTime;
    me._currentData.serviceMode = me._serviceMode;
    me._currentData.locationID = me._locationId;
    me._currentData.userId = me._userId;
    //Cache value
    me.CacheData();
    const groupData = new GroupManageData();
    groupData.groupName = me._currentData.groupName;
    groupData.groupId = me._groupId;
    groupData.creatorName = me._currentData.creatorName;
    groupData.groupDeliveryAddress = me._currentData.groupDeliveryAddress;
    groupData.selectedServiceTime = me.serviceTime;
    groupData.selectedOrderTime = me.orderTime;
    groupData.userId = me._userId;
    me._displayGroupNavSubject.next(!Utils.IsNull(groupData.userId) && groupData.userId > 0);
    // update data
    me._ChangeUiData(groupData);
  }

  /** Call to update data */
  private _ChangeUiData(newData: GroupManageData) {
    const me = this;
    if (
      me._groupManageData.userId !== newData.userId ||
      me._groupManageData.groupName !== newData.groupName ||
      me._groupManageData.groupId !== newData.groupId ||
      me._groupManageData.creatorName !== newData.creatorName ||
      me._groupManageData.selectedOrderTime !== newData.selectedOrderTime ||
      me._groupManageData.selectedServiceTime !== newData.selectedServiceTime ||
      me._groupManageData.groupDeliveryAddress !== newData.groupDeliveryAddress) {
      me._groupManageData = newData;
      me._uiDataChanged.next(me.groupManageData);
    }
  }

  /**
  * Retrieves the current location data and updates the location data subject.
  *
  * @returns A promise that resolves when the location data has been updated.
  */
  public async getCurrentLocationData(): Promise<void> {
    const me = this;
    try {
      const location = await me._locationService.GetWebshopLocationViewModelByID(me._locationId);
      const locationData: ILocationData = {
        name: location.label,
        street: location.street,
        zipCode: location.zip,
        city: location.location
      };
      me.locationDataSubject.next(locationData);
    } catch (error) {
      me.handleError("getCurrentLocationData GetWebshopLocationViewModelByID", error)
      throw error;
    }
  }

  /** Sets the grouop creator name */
  public setCreatorName(creatorName: string) {
    const me = this;
    if (me._creatorName !== creatorName) {
      me._creatorName = creatorName;
    }
    return me._creatorName;
  }

  /** Sets the grouop name */
  public setGroupName(groupName: string) {
    const me = this;
    if (me._groupName !== groupName) {
      me._groupName = groupName;
    }
    return me._groupName;
  }

  /** Sets the user name */
  public setuserName(userName: string) {
    const me = this;
    if (me._userName !== userName) {
      me._userName = userName;
    }
    return me._userName;
  }

  /** Customer lead time specified in the portal */
  public get leadTime(): number {
    //TODO get serviceLeadTime portal
    //!Mark test value
    const serviceLeadTime = 30;
    return serviceLeadTime;
  }

  public get timer(): number {
    //TODO get timer portal
    //!Mark test value
    const timer = 5;//5 minutres before order time
    return timer;
  }

  public serviceTime: string = "";
  /** Delivery/Pickup time */
  public setSelectedServiceTime(value: string) {
    const me = this;
    return me.serviceTime = value;
  }

  public orderTime: string = "";
  /** Order end time (the group has finished the order)*/
  public setSelectedOrderTime(value: string) {
    const me = this;
    return me.orderTime = value;
  }

  /**  Formats the given dateTime string */
  public timeDisplayValue(dateTime: string) {
    return moment(dateTime).format('HH:mm');
  }

  /** Formats the given date string */
  public dayDisplayValue(date: string) {
    const me = this;
    return moment(date).format('DD-MM-YYYY');
  }

  /** Check if selected day is today */
  public isDayToday(selectedDay: string) {
    const today = moment().startOf('day');
    const isToday = moment(selectedDay).isSame(today, 'day');
    return isToday;
  }

  /** Change and set user state ready */
  public async changeAndSetUserStateReady(memberId: number, ready: boolean): Promise<void> {
    const me = this;
    const newStatus = ready ? MemberStatus.Ready : MemberStatus.NotReady;
    await me.PatchMemberStatus(me.groupId, memberId, { status: newStatus });
  }

  /** Add comment to item */
  public async addComment(item: Article): Promise<void> {
    const me = this;
    await me.PutArticle(me.groupId, me.userId, item);
  }

  /** State: payment process started */
  public async setGroupPaymentStatus(status: Status) {
    const me = this;
    await me.PatchGroupStatus(me.groupId, { status: status });
  }

  public async setTotalPaidPrice(totalPaidPrice: number): Promise<boolean> {
    const [statusCode] = await this.PatchGroupTotalPaidPrice(this.groupId, { totalPaidPrice });
    return statusCode === 204;
  }

  private _allMembersAreReady: boolean = false;

  public async loadBasketData(): Promise<void> {
    const me = this;
    let groupBasket_itemsCount = 0;
    let groupBasket_itemsPrice = 0;
    const groupData = await me.getGroupData();
    for (const item of groupData.basket_items) {
      groupBasket_itemsCount += item.count;
      groupBasket_itemsPrice += item.count * item.price;
    }
    // update data
    me._setGroupBasketCount(groupBasket_itemsCount);
    me._setGroupBasketPrice(Utils.centsToCurrency(groupBasket_itemsPrice));
    me._setGroupMembersCount(groupData.members.length);
    // checkMembersState
    const allMembersAreReady: boolean = groupData.members.every((member) => member.stateReady === MemberStatus.Ready);
    if (me._allMembersAreReady != allMembersAreReady) {
      me._allMembersAreReady = allMembersAreReady;
      me._allMembersAreReadySubject.next(me._allMembersAreReady);
    }
    // load state ready by id
    const user = groupData.members.find(member => member.userId === me.userId);
    if (user) {
      const newState = user.stateReady === MemberStatus.Ready;
      me._stateReadySubject.next(newState);
    }
  }

  private _groupBasketCount: number = 0;
  /** All basket items */
  private _setGroupBasketCount(value: number): void {
    const me = this;
    if (me._groupBasketCount != value) {
      me._groupBasketCount = value;
      me._groupBasketItemsCountSubject.next(value);
    }
  }

  private _groupBasketPrice: number = 0;
  /** All basket items */
  private _setGroupBasketPrice(value: number): void {
    const me = this;
    if (me._groupBasketPrice != value) {
      me._groupBasketPrice = value;
      me._groupbasketTotalPriceSubject.next(value);
    }
  }

  private _membersCount: number = 0;
  /** Members */
  private _setGroupMembersCount(memberCount: number) {
    const me = this;
    if (me._membersCount != memberCount) {
      me._membersCount = memberCount;
      me._memberCountSubject.next(me._membersCount);
    }
  }

  /**  Checks if the current user is the creator of the group order. */
  public get userIsGroupCreator() {
    const me = this;
    return me.userId === me._creatorId;
  }

  /**
  * Checks if the group is full based on the number of participants and the settings from the webshop.
  * @returns Resolves to true if the group is full.
  */
  public async checkGroupFullStatus(): Promise<boolean> {
    const me = this;
    const memberlimit = await this.retrieveGroupInformation(this.groupId).then(info => info.MemberLimit);
    let participants_per_group = 30;
    if (memberlimit && memberlimit > 0) {
      participants_per_group = memberlimit;
    }
    return new Promise<boolean>((resolve) => {
      me.memberCount$.subscribe((memberCount) => {
        resolve(memberCount >= participants_per_group);
      });
    });
  }

  /** Mitglied verläst die gruppe, creater schliesst diese dabei.
   * Achtung: Navigate to startscreen by caller
   * Artikel des Mitglieds werden automatisch dagei entfernt
   */
  public async leaveGroup(): Promise<void> {
    // await this.SignalR_ExitGroup(this.groupId, this.userId);
    // DeleteMembership ist für den Use Case "Gruppe verlassen" und ist bereits implementiert.
    await this.DeleteMembership(this.groupId, this.userId);
    await this.cleanupGroupConnection(0 /* done */);
  }

  public async createGroup() {
    const me = this;
    if (Utils.IsNullOrWhiteSpace(me._groupName)) {
      me._coreLogService.error("RemoteGroupOrderService.createGroup", "group name is empty or whitespace-only");
      const failResult: CreateGroupResult = { Variant: CreateGroupVariant.Fail };
      return failResult;
    }
    const serviceMode = this._webshopService.getServiceMode();
    let groupAddress = "";
    if (serviceMode === WebShopMode.DeliveryGroup) {
      const currentAddress = {
        currentlyUsedZipcode: this._webshopService.currentlyUsedZipcode,
        currentlyUsedCity: this._webshopService.currentlyUsedCity,
        currentlyUsedAddress: this._webshopService.currentlyUsedAddress,
        currentlyUsedGeoCoordinates: this._webshopService.currentlyUsedGeoCoordinates,
      };
      groupAddress = JSON.stringify(currentAddress);
    }
    if (this.groupSummary && this.groupSummary !== null) {
      await this.cleanupGroupSummary();
      this.resetGroupPaymentState();
    }

    const payload: PostGroupArgs = {
      // Username: this._userName,
      GroupName: this._groupName,
      Username: this._creatorName,
      Address: groupAddress, // TODO PLZ, Ort, Coordinaten in eingenen variablen merken
      ServiceTimeStamp: this.serviceTime,
      OrderTimeStamp: this.orderTime,
      HypCusNr: this._webshopService.locationID,
    };

    const [_statusCode, createGroupResult] = await this.PostGroup(payload);

    if (createGroupResult.Variant !== CreateGroupVariant.Okay) {
      return createGroupResult;
    }
    const group = createGroupResult.Group;
    const groupCreator = group.Members[0];

    this._groupId = group.Id;
    this._groupName = group.Name;
    this._creatorName = groupCreator.Name;
    this._userName = this._creatorName;
    this._userId = groupCreator.MemberId;
    this._locationId = group.HypCusNr;
    this._serviceMode = group.PreOrderType.Variant as any as WebShopMode;
    this.serviceTime = group.ServiceTimestamp;
    this.orderTime = group.OrderTimestamp;
    this._setGroupDataValue();

    if (this.serviceMode !== serviceMode) {
      throw new Error("Service mode mismatch");
    }

    this.initSignalRIfDataAvailable(group.HypCusNr, group.Id, 1);
    this._setGroupMembersCount(group.Members.length);
    // start timer and load a dialog 5 minutes before order time
    this.startOrderTimer(createGroupResult.Variant === CreateGroupVariant.Okay);
    return createGroupResult;
  }

  // Group entry
  public async retrieveGroupInformation(groupId: number): Promise<Group | null> {
    return await this.GetGroup(groupId).then(([_status, group]) => group);
  }

  public async joinGroup(groupId: number, username: string): Promise<GroupEntryDone> {
    if (Utils.IsNull(groupId)) {
      return Promise.reject("groupid not found");
    }
    return new Promise<GroupEntryDone>(async (resolve, reject) => {
      try {
        const me = this;
        let groupName = null;
        let groupCreator = null;
        let oldUserId = null;
        let userName = null;
        let serviceTime = null;
        let OrderTime = null;
        let OrderType = null;
        let location = null;
        if (me._currentData.groupId === groupId) {
          // try get old place
          groupName = me._currentData.groupName;
          groupCreator = me._currentData.creatorName;
          oldUserId = me._currentData.userId;
          userName = me._currentData.userName;
        } else {
          const info = await me.retrieveGroupInformation(groupId);
          groupName = info.Name;
          groupCreator = info.Members[0].Name;

          const groupCreatorMember = info.Members[0];

          this._groupId = info.Id;
          this._groupName = info.Name;
          this._creatorName = groupCreatorMember.Name;
          this._locationId = info.HypCusNr;
          // this works without converting
          this.serviceTime = info.ServiceTimestamp;
          this.orderTime = info.OrderTimestamp;
          this._serviceMode = info.PreOrderType.Variant as any as WebShopMode;
          this._setGroupDataValue();

          // try load cached data
          const cachedData = await me.UpdateAndLoadCacheData();
          if (cachedData && cachedData.groupId === groupId) {
            oldUserId = cachedData.userId;
            userName = cachedData.userName;
          }
        }
        let groupEntryData: GroupEntryDone = null;
        // TODO: uncomment as soon as this works
        // hangs forever
        // try gets old place
        // if (oldUserId !== null) {
        //   const oldPlace = await me._assignUserToGroup(groupName, groupId, groupCreator, username, oldUserId);
        //   if (oldPlace.success) {
        //     groupEntryData = oldPlace;
        //   }
        // }
        // gets new place
        if (groupEntryData == null) {
          const newPlace = await me._assignUserToGroup(groupName, groupId, groupCreator, username, null);
          groupEntryData = newPlace;
        }
        return resolve(groupEntryData);

      } catch (error) {
        this.handleError("JoinGroup catch", error)
        return Promise.reject(error);
      }

    })

    // const [_code, memberOptional] = await this.PostMembership(groupId, { username });
    // if(!memberOptional) {
    //   return Promise.reject("member could not be created");
    // }
    // const member = memberOptional;
    // this._assignUserToGroup(groupName, groupId, groupCreator, member.Name, member.MemberId);

  }

  private async _assignUserToGroup(groupName: string, groupId: number, groupCreator: string, nickname: string, userId: number): Promise<GroupEntryDone> {
    const me = this;
    return new Promise<GroupEntryDone>(async (resolve, reject) => {
      try {

        const [_statusCode, group] = await this.GetGroup(groupId);
        me._serviceMode = group.PreOrderType.Variant as any as WebShopMode;

        this._setGroupDataValue();
        await me._webshopService.changeServiceMode(me._serviceMode);
        await me._webshopService.setServiceLocationByID(me._locationId);
        if (me._serviceMode === WebShopMode.DeliveryGroup) {
          const currentAddress = JSON.parse(group.PreOrderType.Address);

          await me._webshopService.setCurrentlyUsedAddress(currentAddress.currentlyUsedZipcode, currentAddress.currentlyUsedCity, currentAddress.currentlyUsedAddress, currentAddress.currentlyUsedGeoCoordinates);
        }
        await me.loadBasketData();

        if (!userId) {
          const [_statusCode, memberOptional] = await this.PostMembership(groupId, { username: nickname });
          if (!memberOptional) {
            const failed = new GroupEntryDone();
            failed.success = false;
            failed.status = EntryStatus.Error;
            this.handleError("_assignUserToGroup", "member could not be created");
            return resolve(failed);
            // return reject("member could not be created");
          } else {
            const member = memberOptional;
            const result = new GroupEntryDone();
            result.success = true;
            // we are the newest member, so our memberId === group.Member.length
            let memberCount = memberOptional.MemberId;
            me._setGroupMembersCount(group.Members.length)
            me.setGroupName(groupName);
            me.setCreatorName(groupCreator);
            me.setuserName(nickname);
            me._userId = member.MemberId;
            this._setGroupDataValue();
            this.initSignalRIfDataAvailable(me.currentLocationID, me.groupId, member.MemberId);
            return resolve(result);
          }
        }
        // TODO: what if userId was passed?
      } catch (error) {
        me.handleError("_assignUserToGroup", error)
        return reject("internal error");
      }
    });
  }

  public async tryReassignGuestToPreviousGroup(groupId: number): Promise<boolean> {
    const me = this;
    const cashedData = await me.UpdateAndLoadCacheData();
    if (cashedData && cashedData.userId !== null && cashedData.groupId == groupId) {
      return false; //res.success;
    }
    return false;
  }

  public async notifyPaymentStarted(navigate: boolean = true) {
    const me = this;
    if (!me.userIsGroupCreator) {
      me._openDialogPaymentStartedNoOrderPossible();
      if (navigate) {
        me.goToGroupOverview().then((succes) => {
          if (!succes) {
            me.handleError("notifyPaymentStarted", "Failed to navigate to home screen.");
          }
        });
      }

    }
  }

  public serviceTimeChanged() {
    const me = this;
    me._setGroupDataValue();
  }

  public serviceTimeNotValid(serviceTime: string): boolean {
    const currentTime = new Date();
    const leadTime = 30 * 60 * 1000;
    const selectedServiceTime = serviceTime ? new Date(serviceTime) : null;
    return selectedServiceTime && selectedServiceTime < new Date(currentTime.getTime() + leadTime);
  }

  public ServiceTimeExpired(): boolean {
    const me = this;
    const selectedOrderTime = me.groupManageData.selectedOrderTime ? new Date(me.groupManageData.selectedOrderTime) : null;
    const currentTime = new Date();
    // Validate conditions
    const orderTimePassed = selectedOrderTime && selectedOrderTime < currentTime;
    const serviceTimeExpired = orderTimePassed || me.serviceTimeNotValid(me.groupManageData.selectedServiceTime);;
    return serviceTimeExpired;
  }

  public startOrderTimer(stateOkay: boolean): void {
    if (stateOkay) {
      const selectedOrderTime = new Date(this.groupManageData.selectedOrderTime);
      const minutesBefore = this.timer * 60 * 1000;
      const reminderTime = new Date(selectedOrderTime.getTime() - minutesBefore);
      const timeDifference = reminderTime.getTime() - Date.now();
      // Cancel any existing timer before setting a new one
      this._cancelOrderTimer();
      if (timeDifference > 0) {
        this.orderTimeout = setTimeout(() => {
          this._openReminderDialog();
        }, timeDifference);
      }//else do nothing, order time is already passed
    }

  }

  /** Cancel any existing timer */
  private _cancelOrderTimer(): void {
    if (this.orderTimeout) {
      clearTimeout(this.orderTimeout);
    }
  }

  private async _handleNotifyCreator() {
    const me = this;
    const groupData = await me.getGroupData();
    if (!groupData || !groupData.members) {
      console.error("Group data or members are missing.");
      return;
    }
    // Filter out non-creator members
    const filteredMembers = groupData.members.filter((member) => !member.isGroupCreator);
    // Check if all non-creator members are ready
    const allNonCreatorMembersReady = filteredMembers.length > 0 && filteredMembers.every((member) => member.stateReady === MemberStatus.Ready);
    // Emit notification only if the current user is the creator
    if (allNonCreatorMembersReady && this.userIsGroupCreator) {
      this._notifyCreatorAllMembersAreReady.next(true);
      me._snackBarService.ShowMessage(
        snackBarMessageKey.allMembersAreReady,
        SnackBarMessageType.Info
      );;
    }
  }

  public async cleanConnectionOnPaymentDone() {
    const me = this;
    await me.cleanupGroupConnection(0 /* done */);
  }

  public handleGroupStateFinishedOnAppResume() {
    return this._openDialogOrderCompleted();
  }

  public handleGroupStateDeleteOnAppResume() {
    return this._openDialogGroupClosedCreatorHasLeavedTheGroup();
  }

  /** Displays a notification message when a user joins the group  */
  public ShowMessageUserJoinedTheGroup(userName: string) {
    const me = this;
    return me._snackBarService.ShowMessageUserGroupChange(userName, 'joined');
  }

  /** Handles errors by logging them and opening a warning. */
  private handleError(message: string, error?: any) {
    const me = this;
    me._coreLogService.error("RemoteGroupOrderService", message, error);
  }

  ngOnDestroy(): void { }

  //#region Dialogs

  /**Opens a dialog to inform the group members that the group order
   * has been successfully completed. */
  private _openDialogOrderCompleted() {
    const me = this;
    me._bottomSheetHelperService.open(ConfirmationModalDialogComponent, {
      data: {
        title: "phRemoteOrder_PayResult_Title",
        description: "phRemoteOrder_PayResult_Info",
        buttonText: "phGlobal_Continue",
        icon: true
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });

  }

  /**
 *  Opens a confirmation dialog for a group member for leaving a group.
 *
 * @param callback - indicating whether the user chose to stay (true) or leave (false).
 * @returns {Promise<void>} - A promise that resolves when the dialog is dismissed.
 */
  public async openDialogConfirmLeaveGroupMember(callback: (stay: boolean) => void): Promise<void> {
    const me = this;
    const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phRemoteOrder_Member_Leave_Group_Dialog_Title",
        description: "phRemoteOrder_Member_Leave_Group_Dialog_Content",
        buttonTextAccept: "phGlobal_Return",
        buttonTextDeny: "phRemoteOrder_Member_Leave_Group_Dialog_Button",
        icon: "hypersoft-achtung.svg",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    // acceptBtn returns true
    dialog.afterDismissed().subscribe((stay) => {
      callback(stay);
    });
  }

  /**
*  Opens a confirmation dialog for a group creator for leaving a group.
*
* @param callback - indicating whether the user chose to stay (true) or leave (false).
* @returns {Promise<void>} - A promise that resolves when the dialog is dismissed.
*/
  public async openDialogConfirmLeaveGroupCreator(callback: (stay: boolean) => void): Promise<void> {
    const me = this;
    const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phRemoteOrder_Creator_Leave_Group_Dialog_Title",
        description: "phRemoteOrder_Creator_Leave_Group_Dialog_Content",
        buttonTextAccept: "phGlobal_Return",
        buttonTextDeny: "phRemoteOrder_Creator_Leave_Group_Dialog_Button",
        icon: "hypersoft-achtung.svg",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    // acceptBtn returns true
    dialog.afterDismissed().subscribe((stay) => {
      callback(stay);
    });
  }

  /** Opens a dialog and displays info  that the group has been closed because the creator has left.*/
  private _openDialogGroupClosedCreatorHasLeavedTheGroup() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phRemoteOrder_Creator_Closed_Group_Dialog_Title",
        content: "phRemoteOrder_Creator_Closed_Group_Dialog_Content",
        btnLabel: "phGlobal_Continue",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  /** Opens a dialog and displays info  that the group has been closed because the creator has left.*/
  private _openDialogPaymentStartedNoOrderPossible() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phRemoteOrder_PaymentStarted_NoOrderPossible_Title",
        content: "phRemoteOrder_PaymentStarted_NoOrderPossible_Info",
        btnLabel: "phGlobal_Continue",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  public getTimeLabel() {
    const me = this;
    return me._coreLanguageService.value("phRemoteOrder_Reminder_Info")
      .replace("{time}", me.timer.toString());
  }

  /** open reminder time dialog */
  private _openReminderDialog() {
    const me = this;
    const label = me.getTimeLabel()
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phRemoteOrder_Reminder_Title",
        content: label,
        btnLabel: "phGlobal_Continue",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  //#end Dialogs

  // laut browser konsole geht nur eine anfrage ein, aber im backend kommt zwei mal die gleiche an
  // diese funktion wird auch nur einmal aufgerufen
  // kann es möglich sein, dass es beim OPTIONS aufruf einen bug gibt und der browser dann nochmal die anfrage schickt?
  // ist dies der fall, dann würde dieses verhalten auf dem live system nicht auftreten, da dort eine OPTIONS anfrage nicht nötig ist,
  // weil es keine CORS-Anfrage gibt
  async addArticle(articleData: { ID: number, Count: number }, extraItems: { id: number, count: number }[], comment: string) {
    const article: Article = {
      Id: articleData.ID,
      Count: articleData.Count,
      Extras: extraItems.map(extraItem => {
        return {
          Id: extraItem.id,
          Count: extraItem.count
        }
      }),
      Comment: comment && comment.trim().length > 0 ? comment : "",
    }
    const [statusCode, _] = await this.PostArticle(this.groupId, this.userId, article);
    return statusCode === 204;
  }

  //#region backend api
  getApi() {
    return this._webshopService._objObsInjectHelper.yourAppServer.Api;
  }

  getBearerToken() {
    return this.getApi().YourAppServer.Auth.BearerToken;
  }

  async fetchApi(endpoint: string, payload: any, method?: string, headers?: Record<string, string>): Promise<[HttpStatusCode, any]> {
    const api = this.getApi();

    if (!headers) {
      headers = {};
    }
    headers["Accept"] = "application/json";
    headers["Content-Type"] = "application/json";
    headers["YA-Version"] = appConfig.version;
    if (api.YourAppServer.Auth.IsActive) {
      headers["Authorization"] = "Bearer " + api.YourAppServer.Auth.BearerToken;
    }

    const url = api.YourAppServer.BaseURI + api.MainPath + endpoint

    if (!method) {
      method = "GET";
    }
    const init: any = {
      method,
      headers,
    };
    switch (method.toUpperCase()) {
      // GET and HEAD can't have request bodies
      case "GET":
      case "HEAD":
        break;
      default:
        init.body = JSON.stringify(payload);
    }
    const response = await fetch(url, init);

    const status = response.status;
    if (status === 204) return [status, null];

    return [status, await response.json()];
  }

  // in case of success HttpStatusCode is 200
  public async GetGroup(groupId: number): Promise<[HttpStatusCode, Group | null]> {
    const endpoint = `PreOrder/Group/${groupId}`;
    return await this.fetchApi(endpoint, null);
  }

  public async PostGroup(payload: PostGroupArgs): Promise<[HttpStatusCode, CreateGroupResult]> {
    const endpoint = "PreOrder/Group";
    return await this.fetchApi(endpoint, payload, "POST");
  }

  public async PostMembership(groupId: number, payload: { username: string }): Promise<[HttpStatusCode, Member | null]> {
    const endpoint = `PreOrder/Group/${groupId}/members`;
    return await this.fetchApi(endpoint, payload, "POST");
  }

  // in case of success HttpStatusCode is 204
  public async DeleteMembership(groupId: number, memberId: number): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/members/${memberId}`;
    return await this.fetchApi(endpoint, null, "DELETE");
  }

  // in case of success HttpStatusCode is 204
  public async DeleteGroup(groupId: number): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}`;
    return await this.fetchApi(endpoint, null, "DELETE");
  }

  public async PostComment(groupId: number, payload: { comment: string }): Promise<[HttpStatusCode, string | null]> {
    const endpoint = `PreOrder/Group/${groupId}/members`;
    return await this.fetchApi(endpoint, payload, "POST");
  }

  // in case of success HttpStatusCode is 204
  public async PostArticle(groupId: number, memberId: number, payload: Article): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/members/${memberId}/articles`;
    return await this.fetchApi(endpoint, payload, "POST");
  }

  // in case of success HttpStatusCode is 204
  public async PutArticle(groupId: number, memberId: number, payload: Article): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/members/${memberId}/articles/${payload.Id}`;
    return await this.fetchApi(endpoint, payload, "PUT");
  }

  // in case of success HttpStatusCode is 204
  public async DeleteArticle(groupId: number, memberId: number, article: Article): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/members/${memberId}/articles/${article.Id}`;
    return await this.fetchApi(endpoint, article, "DELETE");
  }

  // in case of success HttpStatusCode is 204
  public async PatchMemberStatus(groupId: number, memberId: number, payload: { status: MemberStatus }): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/members/${memberId}/status`;
    return await this.fetchApi(endpoint, payload, "PATCH");
  }

  // in case of success HttpStatusCode is 204
  public async PatchGroupStatus(groupId: number, payload: { status: Status }): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/status`;
    return await this.fetchApi(endpoint, payload, "PATCH");
  }

  // in case of success HttpStatusCode is 204
  public async PatchGroupTotalPaidPrice(groupId: number, payload: { totalPaidPrice: number }): Promise<[HttpStatusCode, null]> {
    const endpoint = `PreOrder/Group/${groupId}/total-paid-price`;
    return await this.fetchApi(endpoint, payload, "PATCH");
  }
  //#endregion backend api

  //#region SignalR
  private GetSocket() {
    return this._webshopService._objObsInjectHelper.yourAppServer.PreOrderSocket;
  }

  private static readonly CALL_PRE_ORDER_JOIN_GROUP = "PreOrder_JoinGroup";
  /**
   * Join the SignalR group communication channel (At this point client must already be a member of the group).
   * @param groupId
   * @param memberId
   * @returns true on success
   */
  private async SignalR_JoinGroup(groupId: number, memberId: number): Promise<boolean> {
    const socket = this.GetSocket();
    return await socket.Send<boolean>(RemoteGroupOrderService.CALL_PRE_ORDER_JOIN_GROUP, this.getBearerToken(), groupId, memberId);
  }

  private static readonly CALL_PRE_ORDER_DISCONNECT = "PreOrder_Disconnect";
  // groupId und memberId sind hier nicht notwendig, da die bestehende SignalR Verbindung diese bereits kennt
  // das gleiche gilt für Token, der Nutzer muss nicht mehr beweisen, dass er der entsprechende Nutzer ist
  // for now reason is number, later it will probably be an enum
  /**
   * Server mitteilen, dass der User die Verbindung trennen möchte
   * @param reason
   * @returns true on success
   */
  private async SignalR_Disconnect(reason: number): Promise<boolean> {
    const socket = this.GetSocket();
    return await socket.Send<boolean>(RemoteGroupOrderService.CALL_PRE_ORDER_DISCONNECT, reason);
  }

  private static readonly CALL_PRE_ORDER_TEST_ECHO = "PreOrder_TestEcho";
  private async SignalR_TestEcho() {
    const socket = this.GetSocket();
    const message = await socket.Send(RemoteGroupOrderService.CALL_PRE_ORDER_TEST_ECHO, "testing echo");
    if (message !== "testing echo") {
      throw new Error(`Server SignalR function "${RemoteGroupOrderService.CALL_PRE_ORDER_TEST_ECHO}" did not return expected message`);
    }
  }

  private static readonly CALL_PRE_ORDER_BROADCAST_MESSAGE = "PreOrder_BroadcastMessage";
  private async SignalR_BroadcastMessage(message: string): Promise<void> {
    const socket = this.GetSocket();
    await socket.Send(RemoteGroupOrderService.CALL_PRE_ORDER_BROADCAST_MESSAGE, message);
  }

  private static readonly EVENT_PRE_ORDER_MEMBER_JOINED = "PreOrder_MemberJoined";
  private handleMemberJoined(newMemberId: number, newMemberName: string) {
    console.log(`${newMemberName} (${newMemberId}) joined your group!`);
    this.ShowMessageUserJoinedTheGroup(newMemberName);
    this.loadBasketData().then(/* no need for wait, only get fresh data */);
    this._membersChangedSubject.next();
  }

  private static readonly EVENT_PRE_ORDER_MEMBER_LEFT = "PreOrder_MemberLeft";
  private handleMemberLeft(memberId: number, memberName: string) {
    console.log(`${memberName} hat die Gruppe verlassen`);
    this.loadBasketData().then(/* no need for wait, only get fresh data */);
    if (this.userIsGroupCreator) {
      this._snackBarService.ShowMessageUserGroupChange(memberName, 'left');
    }
    this._membersChangedSubject.next();
  }

  private static readonly EVENT_PRE_ORDER_GROUP_DELETED = "PreOrder_GroupDeleted";
  private handleGroupDeleted() {
    const me = this;

    // nicht mitglieder informieren, dass die Bestellung erfolgreich war
    if (!me.userIsGroupCreator) {
      me._openDialogGroupClosedCreatorHasLeavedTheGroup()
      me.gotoHome().then((succes) => {
        if (!succes) {
          me._coreLogService.error("RemoteGroupOrderService.handleGroupDeleted", "Failed to navigate to home screen.");
        }
      });
      me.cleanupGroupConnection(0 /* done */).then(() => { /* no wait */ });
      me._groupNotActiveSubject.next(true);
    } // else creator, navigate by self and
    me._groupDeletedSubject.next();
    me._cancelOrderTimer();

  }

  private static readonly EVENT_PRE_ORDER_COMMENT_ADDED = "PreOrder_CommentAdded";
  private handleCommentAdded(comment: string) {
    console.log(`A new comment was added: ${comment}`);
    this.loadBasketData().then(/* no need for wait, only get fresh data */);
    this._itemsChangedSubject.next();
  }

  private static readonly EVENT_PRE_ORDER_ARTICLE_ADDED = "PreOrder_ArticleAdded";
  private handleArticleAdded(memberId: number, article: Article) {
    console.log(`Member with ID ${memberId} added an article:`, article);
    this.loadBasketData().then(/* no need for wait, only get fresh data */);
    this._itemsChangedSubject.next();
  }

  private static readonly EVENT_PRE_ORDER_ARTICLE_SET = "PreOrder_ArticleSet";
  private handleArticleSet(memberId: number, article: Article) {
    console.log(`Member with ID ${memberId} set an article:`, article);
    this.loadBasketData().then(/* no need for wait, only get fresh data */);
    this._itemsChangedSubject.next();
  }

  private static readonly EVENT_PRE_ORDER_ARTICLE_REMOVED = "PreOrder_ArticleRemoved";
  private handleArticleRemoved(memberId: number, article: Article) {
    console.log(`Member with ID ${memberId} removed an article:`, article);
    this._itemsChangedSubject.next();
  }

  private static readonly EVENT_PRE_ORDER_MEMBER_STATUS_CHANGED = "PreOrder_MemberStatusChanged";
  private handleMemberStatusChanged(memberId: number, status: number) {
    console.log(`Member with ID ${memberId} changed status to ${status}.`);
    this.loadBasketData().then(/* no need for wait, only get fresh data */);
    this._memberStateChangedSubject.next();
    if (status === MemberStatus.Ready) {
      this._handleNotifyCreator();
    }
  }

  private static readonly EVENT_PRE_ORDER_GROUP_STATUS_CHANGED = "PreOrder_GroupStatusChanged";
  private handleGroupStatusChanged(status: number) {
    const me = this;
    console.log(`Group status changed to ${status}.`);
    me.loadBasketData().then(async () => {
      if (status === Status.Finished) {
        await me.setCacheGroupSummary();
        // nicht mitglieder informieren, dass die Bestellung erfolgreich war
        if (me._currentData && me._currentData.userId !== me._creatorId) {
          //quellen für info hier noch möglich: this._groupManageData oder const data = await me.gerGroupData();
          me._openDialogOrderCompleted();
          me.gotoHome().then((succes) => {
            if (!succes) {
              me._coreLogService.error("RemoteGroupOrderService.handleGroupStatusChanged", "Failed to navigate to home screen.");
            }
          });
        } // creator, löst es aus, und muss nichts tun
        await me.cleanupGroupConnection(0 /* done */);
      }
    });
    me._cancelOrderTimer();
    me._groupStatusPaymentStartedSubject.next(status === Status.Finishing);
    me._groupStatusFinishedSubject.next(status === Status.Finished);
    me._groupStatusChangedSubject.next();
  }

  // currently used for debugging
  // could be used for group chat
  private static readonly EVENT_PRE_ORDER_BROADCAST_MESSAGE_RECEIVED = "PreOrder_BroadcastMessageReceived";
  private handleBroadcastMessageReceived(memberId: number, message: string) {
    console.log(`Member ${memberId} sent broadcast message: ${message}`);
  }

  private bindSignalREvents() {
    const socket = this.GetSocket();
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_MEMBER_JOINED, this.handleMemberJoined.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_MEMBER_LEFT, this.handleMemberLeft.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_GROUP_DELETED, this.handleGroupDeleted.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_COMMENT_ADDED, this.handleCommentAdded.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_ARTICLE_ADDED, this.handleArticleAdded.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_ARTICLE_SET, this.handleArticleSet.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_ARTICLE_REMOVED, this.handleArticleRemoved.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_MEMBER_STATUS_CHANGED, this.handleMemberStatusChanged.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_GROUP_STATUS_CHANGED, this.handleGroupStatusChanged.bind(this));
    socket.On(RemoteGroupOrderService.EVENT_PRE_ORDER_BROADCAST_MESSAGE_RECEIVED, this.handleBroadcastMessageReceived.bind(this));
  }

  //#endregion SignalR

  private async cleanupGroupConnection(reason: number): Promise<void> {
    const socket = this.GetSocket();
    this._coreLogService.debug("RemoteGroupOrderService.cleanupGroupConnection", "cleanupGroupConnection", reason);
    if (socket.Status !== ConnectionState.Disconnected) {
      await this.SignalR_Disconnect(reason);
      await this.closeSignalR();
    }
    await this.CleanupCacheData();
    this._groupManageData = new GroupManageData(); // empty belassen
    this._groupName = "";
    this.orderTime = "";
    this._webshopService.resetWebshopService();
    this._coreLogService.debug("RemoteGroupOrderService.cleanupGroupConnection", "toggle events");
    // events für übrige funktionen anstossen
    this._userId = 0;
    this._groupId = 0;
    this._stateReadySubject.next(false);
    this._allMembersAreReadySubject.next(false);
    this._groupStatusChangedSubject.next();
    this._groupStatusFinishedSubject.next(true);
    this._membersChangedSubject.next();
    this._itemsChangedSubject.next();
    this._groupbasketTotalPriceSubject.next(0);
    this._groupBasketItemsCountSubject.next(0);
    this._memberCountSubject.next(0);
    this._displayGroupNavSubject.next(false);
  }

  // todo sollte intern sein, und nur einen cache returnen nicht daten vom server
  public async getGroupData(): Promise<GroupUiData> {
    const me = this;
    const [_httpStatusCode, group] = await me.GetGroup(me.groupId);
    const members = new Array<GroupMemberUiData>();
    const basket_items = new Array<GroupBasketItemUiData>();
    if (group) {
      group.Members.forEach((member) => {
        const groupMember: GroupMemberUiData = {
          isGroupCreator: member.MemberId === 1,
          groupId: me.groupId,
          userId: member.MemberId,
          name: member.Name,
          stateReady: member.Status,
          isOrdering: member.Status === MemberStatus.NotReady,
        };
        members.push(groupMember);
      });

      for (const memberId in group.Basket) {
        if (group.Basket.hasOwnProperty(memberId)) {
          const articles = group.Basket[memberId];
          await Utils.asyncForEach(articles, async (article) => {
            const productdata = await me.getProductDetailsByID(article.Id);
            if (productdata && productdata.product && productdata.details) {
              const basket_item: GroupBasketItemUiData = {
                article: article,
                userId: parseInt(memberId),
                id: article.Id,
                productId: productdata.product.product_id,
                name_de: productdata.product.label_de,
                name_en: productdata.product.label_en,
                valid_date: 20250101, // warum ein valitdate? das muss in die gruppen warenkorb
                deposit: productdata.product.dep_ah,
                extras: article.Extras.map((extra, i) => {
                  const item_extra: IRemoteGroupBasketItemExtra = {
                    id: extra.Id,
                    title: "",
                    title_de: "",
                    title_en: "",
                    count: extra.Count,
                    subIndex: 0, // warum ist das subIndex nicht zurückgegeben worden? es muss in den Gruppen basket
                  }
                  return item_extra;
                }),
                count: article.Count,
                price: Math.floor(productdata.details.baseprice * 100),
                priceWithoutExtras: productdata.details.baseprice,
                comment: article.Comment
              }
              if (basket_item.extras.length > 0) {
                for (const extra of basket_item.extras) {
                  const extraDetails = productdata.details.extras.find(extraDetails => extraDetails.id === extra.id);
                  if (extraDetails) {
                    extra.title = extraDetails.title_de;
                    extra.title_de = extraDetails.title_de;
                    extra.title_en = extraDetails.title_en;
                    try {
                      // TODO PE feststellen und anwenden auf die extraDetails.prices
                      const extraPrice = Math.floor(extra.count * (extraDetails.price * 100));
                      basket_item.price += extraPrice;
                      basket_item.priceWithoutExtras = basket_item.price - extraPrice;
                      const extraDepositAH = Utils.moneyRound(extra.count * extraDetails.dep_ah);
                      basket_item.deposit += extraDepositAH;
                    } catch (error) {
                      me._coreLogService.error("RemoteOrderGroupOverviewService.convertGroupDataToUiData", "extraDetails.price[0]", error);
                    }
                  } else {
                    me._coreLogService.error("RemoteOrderGroupOverviewService.convertGroupDataToUiData", "no extra", extra.id);
                  }
                }
              }
              basket_items.push(basket_item);
            } else {
              me._coreLogService.error("RemoteOrderGroupOverviewService.convertGroupDataToUiData", "getProductDetailsByID no product or details", article.Id);
            }
          });
        }
      }
    }
    const groupUiData: GroupUiData = { members, basket_items };
    return groupUiData;
  }

  /** Navgiert zum Homescreen */
  private gotoHome(): Promise<boolean> {
    return this._router.navigate(["/"]);
  }
  /** Navgiert zum Homescreen */
  private goToGroupOverview(): Promise<boolean> {
    return this._router.navigate(["/remoteOrderGroupOverview"]);
  }

  /** ermittelt die Product details zu einer Product.ID */
  private async getProductDetailsByID(product_id: number): Promise<{ product: ProductDataModel4, details: ProductDetailsDataModel3 }> {
    const me = this;
    const product = await me._productService.GetProduct(me._webshopService.locationID, me._webshopService.sortiment, product_id);
    if (!product) {
      me._coreLogService.error("RemoteOrderGroupOverviewService.getProductDetailsByID", "_productService.GetProduct", "Product not found", me._webshopService.locationID, me._webshopService.sortiment, product_id);
      return null;
    }
    const productDetails = await ProductDetailsHelperService.GetProductDetails(product, me._objObsInjectHelper, true, false);
    return { product: product, details: productDetails };
  }
}